import React, { useState } from 'react';
import './HelpCenter.css';

import { PageTitle, FaqItem, CaseTabs } from '../../../components';
import { support } from '../../../constants';

const HelpCenter = () => {

  // Extract available support categories from imported constants
  const categories = Object.keys(support);

  // State to track currently selected category tab
  const [category, setCategory] = useState(categories[0]);

  // State to manage expanded FAQ per category
  // Initialize with the first FAQ in each category open by default
  const [expandedFaqs, setExpandedFaqs] = useState(() => {
    const initialExpanded = {};
    categories.forEach((cat) => {
      if (support[cat]?.[0]?.question) {
        initialExpanded[cat] = support[cat][0].question;
      }
    });
    return initialExpanded;
  });

  // Handles toggle of accordion for a given FAQ within the selected category
  const handleAccordionClick = (id) => {
    setExpandedFaqs((prev) => ({
      ...prev,
      [category]: prev[category] === id ? null : id, // Collapse if already open, otherwise expand
    }));
  };

  return (
    <>
      {/* Page heading */}
      <PageTitle title={'Help Center'} page={'Help Center'} />

      <section className='help-center'>
        <div className='tab-info'>

          {/* Render category tabs */}
          <ul className="tab-buttons">
            {categories.map((item) => (
              <CaseTabs
                key={item}
                id={item}
                title={item.replace(/([A-Z])/g, ' $1').trim()} // Format camelCase or PascalCase into readable format
                setSelected={() => setCategory(item)} // On click, update active category
                active={category === item} // Highlight currently active tab
                Icon={true} // Enable icon rendering
              />
            ))}
          </ul>

          {/* Render FAQs for the selected category */}
          <div className='tab-sections'>
            <div className='faq tab-section active'>
              <div className='accordion-container'>

                {/* Map through FAQs and render each as an accordion item */}
                {support[category].map((faq) => (
                  <FaqItem
                    key={faq.question}
                    id={faq.question}
                    title={faq.question}
                    content={faq.answer}
                    isActive={faq.question === expandedFaqs[category]} // Open only the active one
                    onAccordionClick={handleAccordionClick} // Toggle expand/collapse
                  />
                ))}

              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default HelpCenter;